import { useServices, useSession } from '../AppServicesContext';
import { useActiveRecording } from '../session/ActiveRecordingContext';
import { SessionLock } from '../session/SessionLock';
import { useIdleTimer } from '../session/useIdleTimer';

/** Блокировка веба после бездействия (ПОРТ-22; по умолчанию 30 минут, политика сервера) и экран разблокировки. */
export function SessionLockGate() {
  const { session } = useServices();
  const { state } = useSession();
  const recording = useActiveRecording();
  const active = state.status === 'authenticated' && !state.locked;
  useIdleTimer({ timeoutMs: state.lockPolicy.idleMinutes * 60_000, onIdle: () => session.lock(), enabled: active });
  if (!state.locked) return null;
  return (
    <SessionLock
      userName={state.user?.fullName ?? null}
      idleMinutes={state.lockPolicy.idleMinutes}
      pinEnabled={state.lockPolicy.pinEnabled}
      onUnlockWithPin={(pin) => session.unlockWithPin(pin)}
      onRequestCode={(channel) => session.requestUnlockCode(channel)}
      onUnlockWithCode={(challengeId, code) => session.unlockWithCode(challengeId, code)}
      onSignOut={() => void session.signOut()}
      recording={recording}
    />
  );
}
